import moment from 'moment';

export class DecimalFormatValueConverter {
  toView(value, decimalPlaces = 4) {
    if (value == null) return '';

    return value.toLocaleString("en-US", { maximumFractionDigits: decimalPlaces, minimumFractionDigits: decimalPlaces });
  }
}
